import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {isOptimizationElement} from './OptimizeTypeUtils';

/**
 * A "Passthrough" Element is one that shouldn't be shown to the user in the Navigator, Breadcrumbs, Outline, tree traversal, etc.
 */
export const isPassthroughElement = (element: ExpressionElement) => {
  return isOptimizationElement(element);
};
